import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setHospitalAuthenticated } from '../redux/actions/user/hospital/Account/login';

export const useInitializeAuthentication = () => {
  const dispatch = useDispatch();
  const hospitalAuth = useSelector((state) => state.hospitalAuth);
  const isAuthenticated = hospitalAuth?.isAuthenticated || false;

  useEffect(() => {
    if (!isAuthenticated) {
      const storedAuth = localStorage.getItem('isAuthenticated');
      console.log('useInitializeAuthentication storedAuth: ', storedAuth);
      if (storedAuth && storedAuth === 'true') {
        // Dispatch an action to update the Redux state.
        dispatch(setHospitalAuthenticated(true));
      }
    }
  }, [dispatch, isAuthenticated]);

  console.log('useInitializeAuthentication isAuthenticated: ', isAuthenticated);
};
